import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const fmtDate = (iso) => {
    if (!iso) return "—";
    return new Date(iso).toLocaleString("en-IN", {
        day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
};

const fmtDay = (iso) => {
    if (!iso) return "—";
    return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

/** Export filtered leads to a landscape PDF table. */
export const exportLeadsPdf = (leads, { dateFrom = "", dateTo = "", purposeLabel, intentLabels = {} } = {}) => {
    const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });

    doc.setFillColor(237, 28, 36);
    doc.rect(0, 0, 297, 22, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(16);
    doc.text("Servall Bikes — Leads Report", 14, 14);

    doc.setTextColor(60, 60, 60);
    doc.setFontSize(9);
    const rangeLabel = dateFrom || dateTo
        ? `Period: ${dateFrom || "start"} → ${dateTo || "today"}`
        : "Period: All dates";
    doc.text(`${rangeLabel}  |  ${leads.length} lead${leads.length === 1 ? "" : "s"}  |  Generated ${fmtDate(new Date().toISOString())}`, 14, 28);

    const head = [["Date", "Name", "Phone", "Purpose", "Source", "Bike", "City", "Status", "Note"]];
    const body = leads.map((l) => [
        fmtDay(l.created_at),
        l.name || "",
        l.phone || "",
        purposeLabel?.(l.purpose) || l.purpose || "",
        intentLabels[l.intent] || l.intent || "",
        l.bike_name || "",
        l.city || "",
        l.status || "new",
        [l.note, l.admin_note].filter(Boolean).join(" | ").slice(0, 80),
    ]);

    autoTable(doc, {
        startY: 34,
        head,
        body,
        styles: { fontSize: 7.5, cellPadding: 2 },
        headStyles: { fillColor: [10, 37, 64], textColor: 255, fontStyle: "bold" },
        alternateRowStyles: { fillColor: [250, 250, 250] },
        columnStyles: {
            0: { cellWidth: 22 },
            1: { cellWidth: 28 },
            2: { cellWidth: 24 },
            8: { cellWidth: 45 },
        },
        margin: { left: 14, right: 14 },
    });

    const suffix = dateFrom && dateTo ? `${dateFrom}_to_${dateTo}` : Date.now();
    doc.save(`servall-leads-${suffix}.pdf`);
};

/** Parse YYYY-MM-DD to local midnight Date. */
export const parseInputDate = (s) => {
    if (!s) return null;
    const [y, m, d] = s.split("-").map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d, 0, 0, 0, 0);
};

export const endOfDay = (date) => {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
};

export const leadInDateRange = (lead, fromStr, toStr) => {
    if (!fromStr && !toStr) return true;
    const created = new Date(lead.created_at);
    if (Number.isNaN(created.getTime())) return false;
    const from = parseInputDate(fromStr);
    const to = toStr ? endOfDay(parseInputDate(toStr)) : null;
    if (from && created < from) return false;
    if (to && created > to) return false;
    return true;
};

export const datePresetRange = (preset) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const fmt = (d) => {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${y}-${m}-${day}`;
    };
    if (preset === "today") return { from: fmt(today), to: fmt(today) };
    if (preset === "yesterday") {
        const y = new Date(today);
        y.setDate(y.getDate() - 1);
        return { from: fmt(y), to: fmt(y) };
    }
    if (preset === "week") {
        const w = new Date(today);
        w.setDate(w.getDate() - 6);
        return { from: fmt(w), to: fmt(today) };
    }
    if (preset === "month") {
        const m = new Date(today);
        m.setDate(m.getDate() - 29);
        return { from: fmt(m), to: fmt(today) };
    }
    return { from: "", to: "" };
};
